import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Projects } from "../projects/projects.entity";
@Entity('sub_contractors_payments')
export class SubContractorsPayments {
    @PrimaryGeneratedColumn("increment",{name:'id'})
    Id:number;
    @Column("int", {
        name: "sub_contractor_id"
    })
    subContractorId: number;
    @Column("int", {
        name: "cost_center_id"
    })
    costCenterId: number;
    @Column("int", {
        nullable: true,
        name: "project_id"
    })
    projectId: number;
    @Column("varchar",{
        nullable:false,
        length:30,
        name:"sub_contractor"
        })
      subContractor:string;
    @Column({
        nullable: true,
        name: "payment_date",
        type: "date"
    })
    paymentDate: Date;
    @Column({
        nullable: true,
        name: "paid_date",
        type: "date"
    })
    paidDate: Date;

    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;
    
      @Column("int", {
          nullable: false,
          name: "created_user"
      })
      createdUser: number | null;
    
    
      @UpdateDateColumn({
          name: "updated_at",
          type:'datetime'
      })
      updatedAt: Date;
    
      @Column("int", {
          nullable: true,
          name: "updated_user"
      })
      updatedUser: number | null;
    
    
      @VersionColumn({
          default:1,
          name: "version_flag"
      })
      versionFlag: number;

    @ManyToOne(type=>Projects, projects=>projects.projectId,{  nullable:false, })
    @JoinColumn({ name:"project_id"})
    projectsInfo: Projects;
}